import { useBranchContext } from "@/contexts/BranchContext";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Building2 } from "lucide-react";

/** Branch switcher for the header. Replaces global search when multi-branch. */
export function BranchSwitcher() {
  const { selectedBranchId, setSelectedBranchId, branches, isLoading } = useBranchContext();

  if (isLoading) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 rounded-md bg-muted/50 border border-border min-w-[140px]">
        <Building2 className="h-4 w-4 text-muted-foreground shrink-0" />
        <span className="text-sm text-muted-foreground truncate">Loading…</span>
      </div>
    );
  }

  // No branches (free tier, or business not set): show static label
  if (branches.length === 0) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 rounded-md bg-muted/50 border border-border min-w-[120px]">
        <Building2 className="h-4 w-4 text-muted-foreground shrink-0" />
        <span className="text-sm text-muted-foreground truncate">All locations</span>
      </div>
    );
  }

  // Single branch: show name (read-only feel, but still in switcher for consistency)
  if (branches.length === 1) {
    return (
      <div className="flex items-center gap-2 px-3 py-2 rounded-md bg-muted/50 border border-border min-w-[120px] max-w-[180px]">
        <Building2 className="h-4 w-4 text-muted-foreground shrink-0" />
        <span className="text-sm font-medium truncate" title={branches[0].name ?? "Main"}>
          {branches[0].name ?? "Main"}
        </span>
      </div>
    );
  }

  return (
    <Select
      value={selectedBranchId}
      onValueChange={(v) => setSelectedBranchId(v as "all" | string)}
    >
      <SelectTrigger className="w-[180px] max-w-[220px] gap-2">
        <Building2 className="h-4 w-4 text-muted-foreground shrink-0" />
        <SelectValue placeholder="Branch" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="all">All branches</SelectItem>
        {branches.map((b) => (
          <SelectItem key={b.id} value={b.id}>
            {b.name ?? "Branch"}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
